import { ReactNode } from 'react';

import { Icons, Stack, tokens } from '@cast/design-system';

export type AttentionStatus = 'error' | 'warning' | 'neutral';

const STATUS_ICON: Record<AttentionStatus, ReactNode> = {
  error: <Icons.WarningCircle />,
  warning: <Icons.WarningCircle />,
  neutral: <Icons.Wrench />,
};

const STATUS_BACKGROUND: Record<AttentionStatus, string> = {
  error: tokens.theme.bg.status.errorSubtle,
  warning: tokens.theme.bg.status.warningSubtle,
  neutral: tokens.theme.bg.status.neutralSubtle,
};

const STATUS_FOREGROUND: Record<AttentionStatus, string> = {
  error: tokens.theme.fg.status.error,
  warning: tokens.theme.fg.status.warning,
  neutral: tokens.theme.fg.status.neutral,
};

export const AttentionStatusChip = ({
  status,
}: {
  status: AttentionStatus;
}) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{
      width: 20,
      height: 20,
      minWidth: 20,
      minHeight: 20,
      borderRadius: tokens.theme.radius.sm,
      backgroundColor: STATUS_BACKGROUND[status],
      color: STATUS_FOREGROUND[status],
      '& svg': {
        width: 12,
        height: 12,
      },
    }}
  >
    {STATUS_ICON[status]}
  </Stack>
);
